<form [formGroup]="countyForm" class="row">
	<mat-form-field appearance="fill" class="col">
		<mat-label>
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="13"> </mat-spinner>
			</mat-icon>
			{{fieldLabel + (this.isMultiple ? '(s)' : '')}}
		</mat-label>

		<mat-select placeholder="Select Counties" formControlName="countySelect" *ngIf="this.isMultiple"
			(openedChange)="!disabled && loadData($event)" (selectionChange)="select($event.value)" multiple
			[required]="required" [panelClass]="'panel-location-multiple'">
			<mat-select-trigger *ngIf="selectedCountyIds.length > 1">
				{{this.selectedCountyName}}
				<span *ngIf="selectedCountyIds.length > 1">
					(+{{selectedCountyIds.length - 1}} {{selectedCountyIds.length === 2 ? 'other' :
					'others'}})
				</span>
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col">
					<button color="primary" mat-raised-button (click)="selectAll()">
						Select All
					</button>
				</div>
				<div class="col">
					<button color="accent" mat-raised-button (click)="deSelectAll()">
						Deselect All
					</button>
				</div>
			</div>

			<div class="padding-horizontal-md row gx-0">
				<mat-form-field class="col">
					<mat-label>
						Filter
					</mat-label>
					<input matInput type="string" placeholder="by name" formControlName="filter"
						(keydown)="$event.stopPropagation()" #filterRef />
				</mat-form-field>
			</div>

			<mat-paginator class="custom-paginator" (page)="onPageChange($event)" [length]="filteredCounties.length"
				[pageSize]="5" showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 100]">
			</mat-paginator>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">
				Select
			</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option *ngFor="let county of this.filteredCountiesShow" [value]="county.ID">
					{{county.COUNTY_NAME}}
				</mat-option>
			</div>
		</mat-select>
		<mat-select placeholder="Select County" formControlName="countySelect" *ngIf="!this.isMultiple"
			(openedChange)="!disabled && loadData($event)" (selectionChange)="select($event.value)"
			[required]="required" [panelClass]="'panel-location-single'">
			<mat-select-trigger *ngIf="selectedCountyIds.length > 1">
				{{this.selectedCountyName}}
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col">
					<button color="accent" mat-raised-button (click)="deSelectAll(); close();">
						Deselect
					</button>
				</div>
			</div>

			<div class="padding-horizontal-md row gx-0">
				<mat-form-field class="col">
					<mat-label>
						Filter
					</mat-label>
					<input matInput type="string" placeholder="by name" formControlName="filter"
						(keydown)="$event.stopPropagation()" #filterRef />
				</mat-form-field>
			</div>
			<mat-paginator (page)="onPageChange($event)" [length]="filteredCounties.length" [pageSize]="5"
				showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 100]">
			</mat-paginator>
			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">
				Select
			</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option *ngFor="let county of this.filteredCountiesShow" [value]="county.ID">
					{{county.COUNTY_NAME}}
					<!--  - {{county.ID}} - {{county.COUNTY_CODE}} -->
				</mat-option>
			</div>
		</mat-select>
	</mat-form-field>
</form>